import { StorageManager } from '@aws-amplify/ui-react-storage'
import '@aws-amplify/ui-react-storage/styles.css'
import { API, Storage, graphqlOperation } from "aws-amplify"
import { useEffect, useState } from 'react'
import { RiDeleteBin5Line } from 'react-icons/ri'
import ModalConfirm from '../../components/ModalConfirm'
import { createProductLibFile, deleteProductLibFile, updateProductLibProduct } from '../../graphql/mutations'
import { searchFiles } from '../../graphql/queries'

interface removeImageProps {
  key: string
  index: number
  mediaType: string
}

// interface imageMediaProps {
//   product: any
//   mediaType: string
//   image: string
// }

function TabMedia (productInfo: any) {

  // console.log("productInfo : ", productInfo.product)
  const product = productInfo.product

  const PAGE_SIZE = 50
  const [ isLoading, setIsLoading ] = useState<boolean>(false)
  const [ imagePackshots, setImagePackshots ] = useState<any>([])
  const [ imageCover, setImageCover ] = useState<any>([])
  const [ imageOther, setImageOther ] = useState<any>([])
  const [ showConfirmRemove, setShowConfirmRemove ] = useState<boolean>(false)
  const [ removeImage, setRemoveImage ] = useState<removeImageProps>({
    key: "",
    index: 0,
    mediaType: ""
  })

  const currentDate = new Date();
  const formatDate = (date: Date): string => {
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    const year = date.getFullYear();
    return `${year}-${month}-${day}`;
  };

  const fetchImagesCover = async () => {
    /* Fetch data from resize folder */
    const { results } = await Storage.list(`files/thumbnail/${product.barcode}/${product.materialCode}/cover/`, { level: "public", pageSize: PAGE_SIZE })
    const resultFilters = results.filter( coverKey => coverKey.size! > 0)

    const signedUrl = resultFilters.map(async (image: any) => {
      const res = await Storage.get(image.key!, { level: "public" })
      return { key: image.key!, signedUrl: res }
    })
    const s3ImagesPromise = await Promise.allSettled(signedUrl)
    // console.log("s3ImagesPromise : ", s3ImagesPromise)
    setImageCover(s3ImagesPromise)
  }

  const fetchImagesPackshots = async () => {
    const { results } = await Storage.list(`files/thumbnail/${product.barcode}/${product.materialCode}/packshot/`, { level: "public", pageSize: PAGE_SIZE })
    const resultFilters = results.filter( packshotKey => packshotKey.size! > 0)

    const signedUrl = resultFilters.map(async (image: any) => {
      const res = await Storage.get(image.key!, { level: "public" })
      return { key: image.key!, signedUrl: res }
    })
    const s3ImagesPromise = await Promise.allSettled(signedUrl)
    // console.log("s3ImagesPromise : ", s3ImagesPromise)
    setImagePackshots(s3ImagesPromise)
  }

  const fetchImagesOther = async () => {
    const { results } = await Storage.list(`files/thumbnail/${product.barcode}/${product.materialCode}/other/`, { level: "public", pageSize: PAGE_SIZE })
    const resultFilters = results.filter( otherKey => otherKey.size! > 0)

    const signedUrl = resultFilters.map(async (image: any) => {
      const res = await Storage.get(image.key!, { level: "public" })
      return { key: image.key!, signedUrl: res }
    })
    const s3ImagesPromise = await Promise.allSettled(signedUrl)
    // console.log("s3ImagesPromise : ", s3ImagesPromise)

    setImageOther(s3ImagesPromise)
  }

  const createImageRecord = async ({ product }: any, absolutePath: string) => {

    console.log("absolutePath - productInfo : ", absolutePath)
    console.log("product : ", product)
    const sp_gallery = absolutePath.split('_')
    const mediaType = absolutePath.includes("cover") ? "COVER" : 
                      absolutePath.includes("packshot") ? "PACKSHOT" : "OTHER"
    const mediaTypeSub = sp_gallery[sp_gallery.length - 1].includes("F.") ? "FRONT" : "BACK"
    const sp_imagePath = absolutePath.split('/')
    const fileName = sp_imagePath[absolutePath.split('/').length - 1]
    const path = product.barcode+"/"+product.materialCode+"/"+mediaType.toLocaleLowerCase()+"/"+fileName
    const newImageInput = {
      "barcode": product.barcode,
      "brand": product.brand,
      "brandType": product.brandType,
      "category": product.category,
      "classifier": product.classifier,
      "collection": product.collection,
      "color": product.color,
      "functions": JSON.stringify(product.functions),
      "height": product.height,
      "length": product.length,
      "weight": product.weight,
      "width": product.width,
      "weightUnit": product.weightUnit,
      "materialCode": product.materialCode,
      "materialName": product.name,
      "mediaType": mediaType,
      "mediaTypeSub": mediaTypeSub,
      "name": product.name,
      "path": path,
      "productHierachy": product.productHierachy,
      "productLibProductFilesId": product.id,
      "status": product.status,
      "subcategory": product.subcategory,
      "tags": JSON.stringify(product.tags),
      "titleEN": product.titleEN,
      "titleTH": product.titleTH
    }
    console.log("newImageInput : ", newImageInput)
    const imageResponse: any = await API.graphql(
      graphqlOperation(createProductLibFile, {
        input: { ...newImageInput },
      })
    );
    console.log("imageResponse : ", imageResponse)

    /* Update  */
    if (mediaType === "COVER") {

      /* Append image to product.images */
      product.images.push(path)
      const updateProductInput = {
        id: product.id,
        images: JSON.stringify(product.images),
      }
      const productResponse: any = await API.graphql(
        graphqlOperation(updateProductLibProduct, {
          input: { ...updateProductInput },
        })
      );
      console.log("productResponse-create : ", productResponse)
    }
  }

  const removeImageFunction = async () => {
    setIsLoading(true)
    const sp_imagePath = removeImage.key.split('/')
    const mediaType = sp_imagePath[sp_imagePath.length - 2]
    const fileName = sp_imagePath[sp_imagePath.length - 1]
    const removePath = `${product.barcode}/${product.materialCode}/${mediaType}/${fileName}`
    console.log("removePath: ", removePath)

    /* Fecth product lib file by path */
    let resultFetch: any = await API.graphql(
      graphqlOperation(searchFiles, {
        path: removePath,
        limit: 1000,
        from: 0,
      })
    );

    /* if Exists contiune */
    if (resultFetch) {
      const removeId = resultFetch.data.searchFiles.items[0].id
      if (removeId) {

        /* Remove product lib file by id */
        await API.graphql(
          graphqlOperation(deleteProductLibFile, {
            input: { id: removeId }
          })
        )
  
        /* Remove image from storage */
        const pathOriginal = `original/${product.barcode}/${product.materialCode}/${mediaType}/${fileName}`
        const pathFilesDisplay = `files/display/${product.barcode}/${product.materialCode}/${mediaType}/${fileName}`
        const pathFilesThumbnail = `files/thumbnail/${product.barcode}/${product.materialCode}/${mediaType}/${fileName}`
        await Storage.remove(pathOriginal, { level: 'public' });
        await Storage.remove(pathFilesDisplay, { level: 'public' });
        await Storage.remove(pathFilesThumbnail, { level: 'public' });

        /* Update product images */
        if (mediaType.toLocaleUpperCase() === "COVER") {

          /* Filter out image by removePath */
          product.images = product.images.filter((image: any) => image !== removePath)
          const updateProductInput = {
            id: product.id,
            images: JSON.stringify(product.images),
            lastUpdatedDate: formatDate(currentDate),
          }
          const productResponse: any = await API.graphql(
            graphqlOperation(updateProductLibProduct, {
              input: { ...updateProductInput },
            })
          );
          console.log("productResponse-remove : ", productResponse)
        }
        
      } else {
        console.log("removeId is null")
      }
    }


    if (mediaType.toLocaleUpperCase() === "COVER") {
      fetchImagesCover()
    } else if (mediaType.toLocaleUpperCase() === "PACKSHOT") {
      fetchImagesPackshots()
    } else if (mediaType.toLocaleUpperCase() === "OTHER") {
      fetchImagesOther()
    } else {
      console.log("Something went wrong on mediaType : ", mediaType)
    }

    setShowConfirmRemove(false)
    setIsLoading(false)
  }

  useEffect(() => {
    fetchImagesCover()
    fetchImagesPackshots()
    fetchImagesOther()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return <>

      <ModalConfirm show={showConfirmRemove}
        onHide={() => {}}
        title='Remove image Confirmation !!'
        cancelText={'Close'}
        cancelAction={() => setShowConfirmRemove(false)}
        okText={'Confirm'}
        loading={isLoading}
        okAction={() => {
          setIsLoading(true)
          removeImageFunction()
        }}
        okClass='btn-remove'
        maxWidth='max-w-md'
      >
        <>
          <div className='flex flex-col items-center justify-center mb-2 space-y-2 text-center'>
            <RiDeleteBin5Line size={36} color="rgb(225 29 72)"/>
            <h6>Do you want to remove this image ?</h6>
          </div>
        </>
      </ModalConfirm>

    <div
      className="hidden opacity-0 transition-opacity duration-150 ease-linear data-[te-tab-active]:block"
      id="tabs-media"
      role="tabpanel"
      aria-labelledby="tabs-media-tab"
    >
      {/* Section >> Images */}
      <div className="flex flex-wrap mb-6 -mx-3">

        <div className="w-full px-3">
          <label className="block mb-2 text-xs font-bold tracking-wide text-gray-700 uppercase" htmlFor="grid-images">
            images (cover)
          </label>
          <div className="flex flex-row items-center justify-center gap-2 px-2 overflow-x-auto text-center align-middle xs:justify-start">
            {imageCover.map((item: any, index: any) => {
              return (
                <div key={index} className="my-4">
                  <div className="card-media-image relative">
                    <div className="flex flex-row justify-center">
                      <div className="justify-end">
                        <button
                          type="button"
                          className="absolute inline-flex items-center justify-center p-1 bg-rose-100 rounded-3xl text-rose-400 hover:text-rose-500 hover:bg-rose-300 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-red-500"
                          onClick={() => { 
                            setShowConfirmRemove(true)
                            setRemoveImage({
                              key: item.value?.key,
                              index: index,
                              mediaType: "COVER"
                            })
                          }}
                        >
                          <span className="sr-only">Close menu</span>
                          <svg className="w-4 h-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                          </svg>
                        </button>
                      </div>
                      <img
                        className="rounded-t-lg"
                        src={item.value?.signedUrl}
                        alt=""
                      />
                    </div>
                  </div>
                </div>
              );
            })}
          </div>

          <div className="items-center w-full px-3 py-2 mb-6 text-center rounded-md md:mb-0 round">
            <StorageManager
              acceptedFileTypes={[
                // you can list file extensions:
                '.jpeg',
                '.jpg',
                // or MIME types:
                'image/png',
              ]}
              accessLevel="public"
              maxFileCount={10}
              showThumbnails={true}
              path={`original/${product.barcode}/${product.materialCode}/cover/`}
              maxFileSize={20000000}
              isResumable
              displayText={{
                // some text are plain strings
                dropFilesText: 'drag-and-drop here',
                // browseFilesText: 'Open file picker',
                // other are functions that take an argument
                getFilesUploadedText(count) {
                  return `${count} images uploaded`;
                },
              }}
              onUploadSuccess={({ key }) => {
                console.log("key : ", key)
                createImageRecord(productInfo, key!)
                setTimeout(() => {
                    fetchImagesCover()
                }, 5000);
              }}
            />
          </div>
        </div>
        <div className="w-full px-3">
          <label className="block mb-2 text-xs font-bold tracking-wide text-gray-700 uppercase" htmlFor="grid-images">
            images (packshot)
          </label>
          <div className="flex flex-row items-center justify-center gap-2 px-2 overflow-x-auto text-center align-middle xs:justify-start">
            {imagePackshots.map((item: any, index: any) => {
              return (
                <div key={index} className="my-4">
                  <div className="card-media-image relative">
                    <div className="flex flex-row justify-center">
                      <div className="justify-end">
                        <button
                          type="button"
                          className="absolute inline-flex items-center justify-center p-1 bg-rose-100 rounded-3xl text-rose-400 hover:text-rose-500 hover:bg-rose-300 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-red-500"
                          onClick={() => { 
                            setShowConfirmRemove(true)
                            setRemoveImage({
                              key: item.value?.key,
                              index: index,
                              mediaType: "PACKSHOT"
                            })
                          }}
                        >
                          <span className="sr-only">Close menu</span>
                          <svg className="w-4 h-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                          </svg>
                        </button>
                      </div>
                      <img
                        className="rounded-t-lg"
                        src={item.value?.signedUrl}
                        alt=""
                      />
                    </div>
                  </div>
                </div>
              );
            })}
          </div>

          <div className="items-center w-full px-3 py-2 mb-6 text-center rounded-md md:mb-0 round">
            <StorageManager
              acceptedFileTypes={[
                // you can list file extensions:
                '.jpeg',
                '.jpg',
                // or MIME types:
                'image/png',
              ]}
              accessLevel="public"
              maxFileCount={10}
              showThumbnails={true}
              path={`original/${product.barcode}/${product.materialCode}/packshot/`}
              maxFileSize={20000000}
              isResumable
              displayText={{
                // some text are plain strings
                dropFilesText: 'drag-and-drop here',
                // browseFilesText: 'Open file picker',
                // other are functions that take an argument
                getFilesUploadedText(count) {
                  return `${count} images uploaded`;
                },
              }}
              onUploadSuccess={({ key }) => {
                console.log("key : ", key)
                createImageRecord(productInfo, key!)
                setTimeout(() => {
                    fetchImagesPackshots()
                }, 5000);
              }}
            />
          </div>
        </div>
        <div className="w-full px-3">
          <label className="block mb-2 text-xs font-bold tracking-wide text-gray-700 uppercase" htmlFor="grid-images">
            images (other)
          </label>
          <div className="flex flex-row items-center justify-center gap-2 px-2 overflow-x-auto text-center align-middle xs:justify-start">
            {imageOther.map((item: any, index: any) => {
              return (
                <div key={index} className="my-4">
                  <div className="card-media-image relative">
                    <div className="flex flex-row justify-center">
                      <div className="justify-end">
                        <button
                          type="button"
                          className="absolute inline-flex items-center justify-center p-1 bg-rose-100 rounded-3xl text-rose-400 hover:text-rose-500 hover:bg-rose-300 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-red-500"
                          onClick={() => { 
                            setShowConfirmRemove(true)
                            setRemoveImage({
                              key: item.value?.key,
                              index: index,
                              mediaType: "OTHER"
                            })
                          }}
                        >
                          <span className="sr-only">Close menu</span>
                          <svg className="w-4 h-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                          </svg>
                        </button>
                      </div>
                      <img
                        className="rounded-t-lg"
                        src={item.value?.signedUrl}
                        alt=""
                      />
                    </div>
                  </div>
                </div>
              );
            })}
          </div>

          <div className="items-center w-full px-3 py-2 mb-6 text-center rounded-md md:mb-0 round">
            <StorageManager
              acceptedFileTypes={[
                // you can list file extensions:
                '.jpeg',
                '.jpg',
                // or MIME types:
                'image/png',
              ]}
              accessLevel="public"
              maxFileCount={10}
              showThumbnails={true}
              path={`original/${product.barcode}/${product.materialCode}/other/`}
              maxFileSize={20000000}
              isResumable
              displayText={{
                // some text are plain strings
                dropFilesText: 'drag-and-drop here',
                // browseFilesText: 'Open file picker',
                // other are functions that take an argument
                getFilesUploadedText(count) {
                  return `${count} images uploaded`;
                },
              }}
              onUploadSuccess={({ key }) => {
                console.log("key : ", key)
                createImageRecord(productInfo, key!)
                setTimeout(() => {
                    fetchImagesOther()
                }, 5000);
              }}
            />
          </div>
        </div>
      </div>
    </div>
  </>
}

export default TabMedia